import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/user-data`;

axios.defaults.withCredentials = true;

export async function fetchUserData() {
  const { data } = await axios.get(API);
  return data.payload || {};
}

export async function saveUserData(payload) {
  const { data } = await axios.put(API, { payload });
  return data.payload || {};
}

export async function patchUserData(key, value) {
  const { data } = await axios.patch(API, { key, value });
  return data.payload || {};
}
